export default {
  noVendors:
    'You currently have no vendors added to your organisation. Sync with the Budget Control Vendor directory to add vendors',
  vendorDB: 'BOQVendor Database',
  addBOQVendor: 'Add BOQNET vendors',
  addCustomVendor: 'Add custom vendor',
  addVendorToDB: 'Add database vendor',
  addVendorItem: 'Add vendor item',
  adminDB: 'You are in the Admin Vendor Database.',
  vendorDetails: 'Vendor details',
  viewItemList: 'View item list',
  viewAccount: 'View account',
  vendorAddress: 'Enter vendor address',
  contextMenu: {
    details: 'View vendor details',
    remove: 'Remove vendor',
  },
  filters: {
    search: 'Search by vendor {name}',
    name: 'name',
    type: 'Vendor type',
    city: 'Vendor city',
    suburb: 'Vendor suburb',
    boq: 'Budget Control',
    custom: 'Custom',
    itemSearch: 'Search by item',
  },
  createVendor: {
    vendorDetails: {
      title: 'Vendor details',
      subtitle: 'Provide the basic information for this vendor',
      subHeading1: 'Basic details',
      subHeading2: 'Vendor contact info',
    },
    paymentDetails: {
      title: 'Vendor payment details',
      subtitle: 'Provide the payment details for orders to this vendor',
      subHeading1: 'Allowed payment methods',
      subHeading2: 'Vendor account details',
      subHeading3: 'Vendor bank details',
    },
    organisationDetails: {
      title: 'Organisation account details',
      subtitle: 'If you have an account with this vendor, enter the account number below',
    },
    vendorAddress: {
      title: 'Vendor Address',
      subtitle: 'Where is this vendor located?',
    },
    form: {
      vendorAccNo: 'Vendor account number',
      code: 'Code',
      name: 'Vendor name',
      country: 'Country',
      city: 'City',
      suburb: 'Suburb',
      description: 'Vendor description',
      logo: 'Vendor logo',
      landlineNo: 'Vendor landline no.',
      salesRepName: 'Sales rep name',
      salesRepContact: 'Sales rep mobile no.',
      salesRepEmail: 'Sales rep email',
      bank: 'Bank',
      branchCode: 'Branch code',
      accountNo: 'Account number',
      vatRegistered: 'VAT registered',
      vatNo: 'Vendor VAT no.',
      vendorAccountNumber: 'Vendor account number',
      vendorAccountEmail: 'Vendor account email',
      vendorPaymentPeriod: 'Account payment period',
      vendorPaymentPeriodMenuTitle: 'Understanding payment periods',
      vendorPaymentPeriodMenuSettingsLink: 'Organisation settings',
      vendorPaymentPeriodMenuDescription:
        'Account payments are made on your organisation’s scheduled vendor payment date, in accordance with the payment terms agreed with the vendor. The payment period you select determines whether the payment is made at the next payment run, or one, two, or three months later.',
      // Inline CTA appended to the description; shown only when the user can view/edit org settings.
      vendorPaymentPeriodMenuSettingsCta: 'View {settingsLink}',
      paymentMethods: {
        cashOnDelivery: 'Cash on Delivery',
        cashOnDeliveryDescription: 'Paid before the set due date.',
        accountPayments: 'Account payments',
        accountPaymentsDescription: 'Paid when vendor accounts are settled.',
        deposits: 'Deposits',
      },
    },
  },
  editVendor: {
    subHeaders: {
      image: 'Vendor image',
      address: 'Vendor address',
      contactInformation: 'Vendor contact information',
      allowedPaymentMethods: 'Allowed payment methods',
      accountDetails: 'Vendor account details',
      bankDetails: 'Vendor bank details',
    },
    imageConstraint: 'JPG or PNG · max 10 MB',
    imageErrors: {
      size: 'That image is over 10 MB. Choose a smaller file.',
      type: 'Use a JPG or PNG image.',
      unreadable: 'Could not process that image. Try a different file.',
      cropInProgress: 'Confirm or cancel the crop before saving.',
    },
    bankingLocked: "You don't have permission to edit the bank details.",
    bankingLockedSynced:
      'Bank details are managed centrally and cannot be edited on a vendor synced from the BOQNET database.',
  },
  syncBOQVendors: {
    title: 'Vendor sync',
    subtitle:
      'Sync with vendors in order to search for materials and services on offer to your sites bill of quantities.',
    selectAll: 'Select all',
    sync: 'Sync now',
    syncInProgress: 'Vendor syncing in progress..',
    successfullySynced: 'Vendors have been successfully synced.',
  },
  removeImageModal: {
    title: 'Remove vendor image',
    content: 'Are you sure you want to remove this vendor image?',
  },
  removeDocModal: {
    title: 'Remove item document',
    content: 'Are you sure you want to remove this document?',
  },
  removeVendorModal: {
    title: 'Remove vendor',
    boqCatalogue:
      'This vendor and its items will also be removed from every organisation that has synced with it.',
    orphaning:
      'Any BOQ, order, claim or return that already uses this vendor keeps its lines, but those items can no longer be ordered or claimed against.',
    replacing:
      'On each affected BOQ, someone with edit rights will need to replace those items with ones from another vendor. On an approved BOQ, that raises a variation.',
  },
  syncedReachModal: {
    title: 'Update synced organisations?',
    content:
      'This change will apply to the {count} organisation that synced this vendor. | This change will apply to the {count} organisations that synced this vendor.',
    cancelLabel: 'Go back',
  },
  unsavedChangesModal: {
    title: 'Discard changes?',
    content: "You have unsaved changes. They'll be lost if you continue.",
    confirmLabel: 'Discard & Close',
    cancelLabel: 'Keep Editing',
  },
  imageUploadSuccess: {
    title: 'Image uploaded',
    content: 'Image has been uploaded successfully',
  },
  imageRemoveSuccess: {
    title: 'Image removed',
    content: 'Image has been removed successfully',
  },
  imageMutationError: {
    title: 'Image Update Failed',
    content: 'Updating the image failed. Please try again.',
  },
  createVendorSuccess: {
    title: 'Vendor created',
    content: 'Vendor has been successfully created',
  },
  updateVendorSuccess: {
    title: 'Vendor updated',
    content: 'Vendor has been successfully updated',
  },
  removeVendorSuccess: {
    title: 'Vendor removed',
    content: 'Vendor has been successfully removed',
  },
  items: {
    bulkUpload: 'Bulk upload',
    addItem: 'Add item',
    noItems:
      'This vendor currently has no offered materials or services. Add their offerings using the button below.',
    filters: {
      source: 'Source',
      type: 'Item type',
    },
    remove: {
      title: 'Remove item',
      boqCatalogue:
        'This item will also be removed from every organisation that has synced with this vendor.',
      orphaning:
        'Any BOQ, order, claim or return that already includes this item keeps its lines, but the item can no longer be ordered or claimed against.',
      replacing:
        'On each affected BOQ, someone with edit rights will need to replace it with a different item. On an approved BOQ, that raises a variation.',
    },
    table: {
      name: 'Name',
      type: 'Type',
      description: 'Description',
      source: 'Source',
      unitTypeShortName: 'Unit',
      rate: 'Rate',
      lastPaidRate: 'Last paid',
      edit: 'Edit item details',
      delete: 'Delete item',
      emptyState: 'No vendor items have been added yet',
    },
    unsavedChanges:
      'You have unsaved changes to this item. Are you sure you want to close without saving?',
    itemDetails: 'Item details',
    detailsSubtitle: 'Provide the details for this vendor item.',
    documentationSection: {
      title: 'Documentation',
      subtitle: 'Attach any supporting files for this item.',
    },
    form: {
      name: 'Item name',
      skuNumber: 'SKU Nr',
      description: 'Item description',
      type: 'Item type',
      unitType: 'Item unit type',
      rate: 'Item rate/cost',
      documentation: 'Item documentation',
      documentationConstraint: 'PDF, JPG or PNG. Up to {size} MB per file.',
      documentationEmpty: 'No documents yet. Upload a file to get started.',
      documentationTypeError: 'Only PDF, JPG or PNG files can be attached.',
      documentationSizeError: 'This file is larger than the {size} MB limit.',
    },
    toast: {
      add: {
        title: 'Item added',
        content: 'Item has been added successfully',
      },
      update: {
        title: 'Item updated',
        content: 'Item has been updated successfully',
      },
      delete: {
        title: 'Item deleted',
        content: 'Item has been deleted successfully',
      },
      deleteDoc: {
        title: 'Document deleted',
        content: 'Document has been deleted successfully',
      },
      uploadDoc: {
        title: 'Document uploaded',
        content: 'Document has been uploaded successfully',
      },
      uploadDocs: {
        title: 'Documents uploaded',
        content: 'Documents have been uploaded successfully',
      },
    },
  },
  bulkUploadItems: {
    title: 'Upload Bulk item CSV',
    subtitle:
      'Upload CSV file which includes items and products for the selected vendor. You can download the template CSV to populate.',
    upload: 'Upload a file',
    downloadTemplate: 'Download template',
    fileUploaded: 'File uploaded',
    invalidFile: 'Invalid file',
    incorrectFileHeader: 'File header fields do not match template',
    successfulRecords: { text: '{0} records successfully identified', number: '{number}' },
    errorRecords: '{ count } records could not be added due to data errors',
    dataErrors: {
      title: 'What are data errors?',
      description:
        'Data errors may occur when your csv has tiles with the following: Quotation marks. eg. Quotations across delimiters Incorrect formats in fields. eg. Name in a number field Empty fields. eg. Fields identified which should contain data.',
      error: '{error} - Line {line}',
      additionalFields: '+{number} additional fields.',
      line: 'Line',
      field: 'Field:',
      valueProvided: 'Value provided:',
    },
    uploading: {
      title: 'Uploading...',
      duration: 'This can take up to 30 seconds.',
    },
    submitDialog: {
      title: 'Submit item CSV',
      description: 'Are you sure you want to submit this bulk upload file?',
      errorsDescription: {
        title:
          'This csv has fields that could not be imported due to data errors. Are you sure you wish to import the entries that were successful?',
        errors: '{number} fields could not be added due to data errors.',
      },
    },
    successfulUpload: {
      title: 'CSV uploaded',
      content: 'CSV was uploaded successfully',
    },
  },
};
